import { NgClass } from '@angular/common';
import { Component, ElementRef, forwardRef, inject } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FontAwesomeDirective } from '../../font-awesome/font-awesome.directive';
import { AbstractValueAccessorComponent } from '../abstract-value-accessor.component';
import { NgbControlDirective } from '../ngb-control/ngb-control.directive';

@Component({
    selector: 'input-password',
    template: `<div class="input-group">
        <span class="input-group-text bg-white{{ isInvalid ? ' text-danger border-danger' : null }}">
            <i fa="regular" class="fa-sm fa-lock"></i>
        </span>
        <input [type]="inputType" ngbControl [class.is-invalid]="isInvalid"
               [(ngModel)]="value" (change)="onChange($event.target.value)">
        <button type="button" class="btn" (click)="toggleVisibility()"
                [ngClass]="{'btn-outline-secondary': !isInvalid || true, 'btn-outline-danger': isInvalid}">
            <i fa="solid" [ngClass]="{
                  'fa-eye': 'password' === inputType,
                  'fa-eye-slash': 'text' === inputType}"></i>
        </button>
    </div>`,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputPasswordComponent),
        multi: true,
    }],
    imports: [
        FormsModule, NgClass,

        FontAwesomeDirective, NgbControlDirective,
    ],
})
export class InputPasswordComponent extends AbstractValueAccessorComponent {
    private element = inject(ElementRef);
    protected inputType = 'password';
    protected value: string;

    toggleVisibility(): void {
        if ('password' === this.inputType) {
            this.inputType = 'text';
        } else {
            this.inputType = 'password';
        }
    }

    writeValue(obj: string): void {
        this.value = obj;
    }

    get isInvalid(): boolean {
        return this.element.nativeElement.classList.contains('is-invalid');
    }
}
